import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { apiOrganization } from "../../../../../../../../../../../services/Api/Organization/apiOrganization";
import { ReceiptApi } from "../../../../../../../../../../../services/Api/Organization/types";
import ReceiptForm from "./ReceiptForm";
import ReceiptTemplatePreview from "./ReceiptTemplatePreview";

interface Props {
	receipt: ReceiptApi;
}

const ReceiptTemplate = ({ receipt }: Props): JSX.Element => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [newAvatar, setNewAvatar] = useState<string | undefined>(receipt.logo_link?.default_link);
	const [imageFetched, setImageFetched] = useState(false);
	const form = useForm<ReceiptApi>({
		criteriaMode: "all",
		defaultValues: {
			...receipt,
			facebook: receipt.facebook?.replace("fb.com/", ""),
			instagram: receipt.instagram?.replace("instagram.com/", ""),
		},
	});
	const { formState, handleSubmit, reset, getValues, setError } = form;
	const { addSuccessFlash, addFlash } = useFlash();

	const onSubmit = handleSubmit(async (data: ReceiptApi) => {
		if (data.facebook) {
			data.facebook = `fb.com/${data.facebook}`;
		}
		if (data.instagram) {
			data.instagram = `instagram.com/${data.instagram}`;
		}
		if (getValues("logo.image_data") || !newAvatar) {
			data.logo_link = undefined;
		}
		try {
			setLoading(true);
			const res = await apiOrganization.updateReceiptSettings(data);
			reset({
				...res,
				facebook: res.facebook?.replace("fb.com/", ""),
				instagram: res.instagram?.replace("instagram.com/", ""),
			});
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
		} catch (e) {
			handleError.form(e, setError, addFlash);
		} finally {
			setLoading(false);
		}
	});

	return (
		<div className="content-preview">
			<FormDirty formState={formState} loading={loading} key="receipt-form" noValidate onSubmit={onSubmit}>
				<fieldset className="form-group">
					<div className="row">
						<ReceiptTemplatePreview form={form} newAvatar={newAvatar} imageFetched={imageFetched} />
						<ReceiptForm
							receipt={receipt}
							form={form}
							setNewAvatar={setNewAvatar}
							setImageFetched={setImageFetched}
						/>
					</div>
				</fieldset>
			</FormDirty>
		</div>
	);
};

export default ReceiptTemplate;
